module.exports = __webpack_public_path__ + "static/media/no-image.9e0d3041.png";